import { useQuery } from '@tanstack/react-query'
import { getSaathiAnalyticsFetcher } from '@api/fetcher/ambassdor'

interface ReturnType {
  data: any
  isLoading: boolean
  error: any
  isFetching: any
}

const useSaathiAnalytics = ({
  startDate,
  endDate,
  orgId,
  type,
}: {
  startDate: any
  endDate: any
  orgId: string
  type: string
}): ReturnType => {
  const { isLoading, error, data, isFetching } = useQuery(
    [
      'saathi-Analytics',
      {
        startDate: startDate,
        endDate: endDate,
        orgId: orgId,
        type: type,
      },
    ],
    getSaathiAnalyticsFetcher,
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!startDate && !!endDate,
    }
  )
  return {
    data: data?.data?.data,
    error,
    isLoading,
    isFetching,
  }
}

export default useSaathiAnalytics
